import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface ZoneComparisonChartProps {
  data: Array<{
    zoneName: string;
    avgScore: number;
    totalReports: number;
  }>;
}

export const ZoneComparisonChart: React.FC<ZoneComparisonChartProps> = ({
  data,
}) => {
  return (
    <div className="bg-white p-3 sm:p-4 md:p-6 rounded-lg shadow-sm">
      <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">
        Comparación por Zona
      </h3>
      <div className="w-full h-64 sm:h-80 lg:h-96">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="zoneName" style={{ fontSize: '12px' }} />
            <YAxis domain={[0, 100]} style={{ fontSize: '12px' }} />
            <Tooltip
              formatter={(value: number, name: string) => {
                if (name === 'avgScore')
                  return [`${value.toFixed(1)}%`, 'Promedio'];
                return [value, 'Reportes'];
              }}
            />
            <Legend />
            <Bar
              dataKey="avgScore"
              fill="#8b5cf6"
              name="Promedio"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
